const CloseBannerSVG = ({color, setShowCard}) => (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3196_91830)">
            <g clipPath="url(#clip0_3196_91830)">
                <rect width="48" height="48" transform="translate(16 10)" fill={color}
                    onClick={(e) => {
                                    e.stopPropagation();
                                    setShowCard(true);
                    }}
                />
                <path d="M49 31V25M49 25H43M49 25L41.5 32.5M31 37V43M31 43H37M31 43L38.5 35.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </g>
        <defs>
            <filter id="filter0_d_3196_91830" x="0" y="0" width="80" height="80" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="6" />
                <feGaussianBlur stdDeviation="8" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.12 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3196_91830" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3196_91830" result="shape" />
            </filter>
            <clipPath id="clip0_3196_91830">
                <rect x="16" y="10" width="48" height="48" rx="8" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default CloseBannerSVG;